<template>
    <div class="page-message page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">消息列表</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>个人中心</el-breadcrumb-item>
                            <el-breadcrumb-item>消息列表</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
               <!-- <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="coupon_number" label="卡券编号：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.coupon_number" size="small" placeholder="卡券编号" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="收信日期：">
                            <el-date-picker
                                    size="small"
                                    clearable
                                    v-model="data_range"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="status" label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>-->
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <div style="padding-bottom: 20px;">
                            <el-button type="primary" class="btn-bg-p" @click="readMessage('all')">全部标记为已读</el-button>
                            <el-button type="primary" class="btn-bg-o" @click="readDelmultiple()">标记为已读</el-button>
                            <el-button type="primary" class="btn-bg-r" @click="delmultiple()"><i class="el-icon-delete"></i> 批量删除</el-button>
                        </div>
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
                            <el-table-column prop="title" align="center" label="标题" min-width="180">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">[{{scope.row.status_name}}] </span> <span style="margin-left: 5px;"> {{ scope.row.title }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="content" align="center" label="内容" min-width="240">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.content"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="type_name" align="center" label="消息类型" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'tag-span tag-'+scope.row.type">{{scope.row.type_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="c_time" align="center" label="收信时间" min-width="160">
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="160" fixed="right">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.status==0" class="option-btn btn-bd-s" type="primary" size="mini" @click.stop="readMessage(scope.row.message_id)">标记为已读</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click.stop="deleteMessage(scope.row.message_id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import bus from '@/assets/js/defined.js'
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
               /* data_range:'',
                form_search:{
                    coupon_number:"",
                    start_date:'',
                    end_date:-1,
                    status: -1
                },
                init_data: {
                    type_list:[],
                    status_list: [],
                },*/
                get_count:0,
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                }
            }
        },
        created() {
            document.title = '消息列表';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                //var params = _this.form_search;
                var params = {};
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/message/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    /*_this.init_data.type_list = status_list.concat(res.type_name_list);
                    _this.init_data.status_list = status_list.concat(res.status_name_list);*/
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
           /* handleRowClick(row){
                //console.log(row);
                this.readMessage(row.message_id);
            },*/
            readMessage(ids){
                var _this = this;
                var params = {};
                if(ids=='all'){
                    params.is_all = 1;
                }else {
                    params.message_ids = ids;
                }
                this.$client.post('/adminapi/message/read', params, function(res,message){
                    _this.getList();
                    _this.getMessage();
                },function(res){

                });
            },
            getMessage(){
                var _this = this;
                this.$client.post('/adminapi/message/pullMessage', {}, function(res,message){
                    _this.get_count = res.message_count;
                    bus.$emit('countChange',_this.get_count);
                },function(res){

                });
            },
            deleteMessage(message_id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/message/delete', {message_ids:message_id}, function(res,message){
                    _this.getList();
                    _this.getMessage();
                },function(res){

                });
            })
            .catch(() => {});
            },
            readDelmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要标记为已读的消息");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].message_id);
                }
                var ids = idList.join(",");
                _this.readMessage(ids);
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的消息");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].message_id);
                }
                var params = {message_ids:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/message/delete', params, function(res,message){
                    _this.getList();
                    _this.getMessage();
                },function(res){

                });
            })
            .catch(() => {});
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-296)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
            /*data_range(newVal){
                //console.log(newVal);
                if(newVal == null){
                    this.form_search.start_date = '';
                    this.form_search.end_date = '';
                }else{
                    this.form_search.start_date = newVal[0];
                    this.form_search.end_date = newVal[1];
                }
            }*/
        }
    }
</script>
<style>

</style>
<style scoped>
    .status-0{
        color: #FF0000;
    }
    .status-1{
        color: #999999;
    }
</style>